import React from "react";

const CheckBox = ({
  name,
  chkBoxText,
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="flex items-center space-x-2 border rounded  border-gray-200 p-2">
      <input
        id={name}
        type="checkbox"
        name={name}
        disabled={disabled}
        checked={checked}
        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
        onChange={onChange}
      />
      <label
        htmlFor={name}
        className={`text-sm font-medium ${
          disabled
            ? `text-gray-500 cursor-not-allowed`
            : `text-gray-900 cursor-pointer `
        } duration-500
       `}
      >
        {chkBoxText}
      </label>
    </div>
  );
};

export default CheckBox;
